import { fg } from '@confluence/feature-gating';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import {
	CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT,
	CREATION_FOCUSED_NAV_START_TIME,
	CFIND_5565_CREATION_FOCUSED_NAV_XFLOW,
	NAV_EXPERIMENT_ONBOARDING_KEYS,
} from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';

type Result = { data: unknown; hasErrors: boolean };

function getOnboardingKeysToPreload() {
	if (fg('cc_activation_simplify_nav_preloader_enabled')) {
		if (fg('cfind_5565_creation_focused_nav_xflow_preload')) {
			return [...NAV_EXPERIMENT_ONBOARDING_KEYS, CFIND_5565_CREATION_FOCUSED_NAV_XFLOW.START_AT];
		}
		return [...NAV_EXPERIMENT_ONBOARDING_KEYS];
	}
	return [CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT, CREATION_FOCUSED_NAV_START_TIME];
}

export const preloadSideNavigationOnboardingState = (
	onResult?: (result: Result) => void | Promise<void>,
): Promise<Result> => {
	const promise = query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: getOnboardingKeysToPreload(),
		},
	});
	if (onResult) {
		return promise.then(async (result) => {
			await onResult(result);
			return result;
		});
	}
	return promise;
};
